import dayjs from 'dayjs';

/**
 * 限定时间控件
 * 1. 只能选择月内，不可超出
 * 2. 默认本月1号-当日
 * 3. 不可清除
 * <el-date-picker v-bind="dateProps" v-on="dateEvent" />
 * @param string[] whiteList 路由白名单
 * */
export const dateLimit = () => {
  return {
    data() {
      return {
        dateSpot: null,
        dateProps: {
          clearable: false,
          editable: false,
          pickerOptions: {
            onPick: ({ minDate, maxDate }) => {
              if (!maxDate) {
                this.dateSpot = minDate;
              }
            },
            disabledDate: time => {
              if (!this.dateSpot) return false;
              const start = +dayjs(this.dateSpot).startOf('month').format('x');
              const end = +dayjs(this.dateSpot).endOf('month').format('x');
              return time.getTime() < start || time.getTime() > end;
            }
          }
        },
        dateEvent: {
          focus: this.resetDateSpot
        }
      };
    },
    methods: {
      resetDateSpot() {
        this.dateSpot = null;
      }
    }
  };
};
